import { useEffect, useState } from "react"
import { Button, Col, Dropdown, Form, Modal, Row } from "react-bootstrap"
import { getGlobalEmployees } from "../../../redux/employees/actions"
import { useDispatch, useSelector } from "react-redux"
import CustomTable from "../../CustomTable"


const SearchEmployee = ({ empleado, setEmpleado, setShowFormModal, showFormModal }) => {
    const dispatch = useDispatch()
    const [searchType, setSearchType] = useState({ id: "codigo__icontains", desc: "Código de empleado" })
    const [searchValue, setSearchValue] = useState("")
    const searchFilters = [
        { id: "codigo__icontains", desc: "Código de empleado" },
        { id: "nombre__icontains", desc: "Nombre de empleado" },
    ]


    const {
        loading,
        employees,

    } = useSelector((store) => store.employees)

    useEffect(()=> {
        dispatch(getGlobalEmployees({
            filter: {
                nombre__icontains: 0
            }
        }, 2))
        setSearchValue("")
    }, [empleado])

    const onSubmit = (e) => {
        e.preventDefault()

        if (!searchType || !searchValue.trim()) return

        dispatch(getGlobalEmployees({
            filter: {
                [searchType.id]: searchValue.trim()
            }
        }, 2))

    }

    const columns = [
        {
            Header: "Código",
            accessor: "codigo",
            Filter: ""
        },
        {
            Header: "Nombre",
            accessor: "nombre",
            Filter: ""
        },
         {
            id: "customButtons",
            Filter: "",
            Cell: (value) => (
                <Button
                    variant={empleado  && empleado.id === value.row.original.id ? "outline-success" : "outline-primary"}
                    className="rounded-pill"
                    disabled={empleado && empleado.id === value.row.original.id}
                    onClick={() => {
                        setEmpleado(value.row.original)
                        setShowFormModal(false)
                    }}
                > 
                    {empleado && empleado.id === value.row.original.id ? "Seleccionado" : "seleccionar"}
                </Button>
            )
        }

    ]


    return (
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)} size="lg" centered>
            <Form onSubmit={onSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title className="ft-modal-title">
                        Búsqueda de Empleado
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group as={Col} sm="10" className="mb-1">
                        <Form.Label column sm="12" md="12">
                            Empleado (por {searchType.desc})
                        </Form.Label>
                        <Row>
                            <Col sm={10}>
                                <Form.Control
                                    name="nombre"
                                    className="rounded-pill"
                                    required
                                    type="text"
                                    placeholder={`Buscar por ${searchType.desc}`}
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                ></Form.Control>
                            </Col>
                            <Col sm={1}>
                                <Dropdown className="mx-1">
                                    <Dropdown.Toggle
                                        variant="light"
                                        className="btn-sm font rounded-pill"
                                    >
                                        <i className="material-icons">filter_list</i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {searchFilters.map((item) => (
                                            <Dropdown.Item
                                                onClick={() => setSearchType(item)}
                                                key={item.id}
                                            >
                                                {item.desc}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>


                        </Row>

                    </Form.Group>

                    <CustomTable
                        columns={columns}
                        data={employees}
                        isLoadingData={loading}
                    />

                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>

            </Form>


        </Modal>

    )
}

export default SearchEmployee